import { ArrowRightToLine, Delete } from "lucide-react";
import { Button } from "@/components/ui/button";

interface BlockActionsProps {
  onAcceptSuggestion: () => void;
  onRejectSuggestion: () => void;
}

export const BlockActions = ({
  onAcceptSuggestion,
  onRejectSuggestion,
}: BlockActionsProps) => {
  return (
    <div className="absolute top-0 -right-11 flex flex-col gap-2">
      <Button
        onClick={onAcceptSuggestion}
        className="rounded-md border border-positive bg-positive text-positive hover:bg-green-100 hover:border-green-300 p-2 w-8 h-8 flex items-center justify-center"
      >
        <ArrowRightToLine className="h-5 w-5 text-green-600" />
      </Button>
      <Button
        onClick={onRejectSuggestion}
        className="rounded-md border border-negative bg-negative text-negative hover:bg-red-100 hover:border-red-300 p-2 w-8 h-8 flex items-center justify-center"
      >
        <Delete className="h-5 w-5 text-red-600" />
      </Button>
    </div>
  );
};
